const STORAGE_KEY = "kk_impersonation_session";

export function parseImpersonationHash(hash) {
  if (!hash || typeof hash !== "string") return null;
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const params = new URLSearchParams(raw.includes("=") ? raw : "");
  let encoded = params.get("kk_impersonation");
  if (!encoded && raw.startsWith("kk_impersonation=")) {
    encoded = raw.slice("kk_impersonation=".length);
  }
  if (!encoded) return null;
  try {
    return JSON.parse(decodeURIComponent(encoded));
  } catch {
    return null;
  }
}

export function saveImpersonationSession(session) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function loadImpersonationSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session?.token || !session?.ticketId) return null;
    if (session.expiresAt && new Date(session.expiresAt).getTime() < Date.now()) {
      clearImpersonationSession();
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function clearImpersonationSession() {
  sessionStorage.removeItem(STORAGE_KEY);
  try {
    localStorage.removeItem("userInfo");
  } catch {
    /* ignore */
  }
}

export function isImpersonating() {
  return Boolean(loadImpersonationSession());
}

export function getImpersonationToken() {
  return loadImpersonationSession()?.token || null;
}

/** Routes that must stay disabled during Support Mode (UI-side). */
export const IMPERSONATION_FORBIDDEN_PATHS = [
  "/master-account/account/security",
  "/master-account/account/payment",
  "/brand-manager/account/security",
  "/brand-manager/account/payment",
  "/master-account/billing",
];

export function isForbiddenPathDuringImpersonation(pathname) {
  if (!isImpersonating()) return false;
  return IMPERSONATION_FORBIDDEN_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}
